Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconErrorData: "data:image/svg+xml,%3csvg id='art' xmlns='http://www.w3.org/2000/svg' width='24' height='24'%3e%3cdefs%3e%3cstyle%3e.cls-1%7bfill:currentColor%3bstroke-width:0%7d%3c/style%3e%3c/defs%3e%3cpath class='cls-1' d='M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0zm0 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10z'/%3e%3ccircle class='cls-1' cx='12' cy='17.25' r='1.25'/%3e%3cpath class='cls-1' d='M12 14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1s-1 .45-1 1v6c0 .55.45 1 1 1z'/%3e%3c/svg%3e",
  iconErrorWidth: 24,
  iconErrorHeight: 24
};